import { TquestionINT, setQuestion, TtalkStateINTOptions } from '../store/slices/gameObjectSlice';
import { store } from './../store/store';
import { GlobalAnswersINT } from './PropertiesDeclarations';

// Define a mapping from question keys to their valid option keys
export type QuestionKeyToOptionKeys = {
    [K in keyof GlobalAnswersINT]: GlobalAnswersINT[K];
};
export interface QuestionOptions {
    array?: keyof GlobalAnswersINT;
}

// The Title interface
export interface Title<K extends keyof QuestionKeyToOptionKeys = any> {
    text: string,
    key: K extends keyof QuestionKeyToOptionKeys ? K : keyof GlobalAnswersINT,
    options?: QuestionOptions & TtalkStateINTOptions;
}

// Modify the Option interface to use generics
export interface Option<K extends keyof QuestionKeyToOptionKeys = any> {
    title: string,
    key: K extends keyof QuestionKeyToOptionKeys ? QuestionKeyToOptionKeys[K] : any,
    hide?: boolean,
    show?: boolean,
    disabled?: boolean;
    info?: string;
}

// The Question class with generics
export default class Question<K extends keyof QuestionKeyToOptionKeys = any> {
    options: Option<K>[] = [];
    static globalAnswers: GlobalAnswersINT;

    constructor(public title: Title<K>) {
    }

    option(option: Option<K>): Question<K> {
        if (!option.hasOwnProperty('show')) {
            option.show = true;
        }
        this.options.push(option);
        return this;
    }

    private static _initialize = (() => {
        Object.defineProperty(Question, "globalAnswers", {
            get: () => {
                return store.getState().gameObject.present.question.globalAnswers;
            },
        });

    })();
}

